import { Back } from '../../../components/buttons/backButton/Back'
import MainButton from "../../../components/buttons/mainButton/MainButton"
import Field from "../../../components/textField/Field"
import { translations } from "../../../configs/translations"
import { useStore } from "../../../store/store"

interface PasswordRecoveryWindowProps {
    password: string;
    errors: any;
    registerField: any;
    onSubmit: () => void;
    onBack: () => void;
}

export const PasswordRecoveryWindowPassword = ({
    password,
    errors,
    registerField,
    onSubmit,
    onBack
}: PasswordRecoveryWindowProps) => {
    const language = useStore(state => state.language);
    const t = translations[language];


    return (
        <div className="container">
            <div className="window window-recovery">
                <div className="window-recovery-back-button">
                    <Back onClick={() => onBack()} text={""} />
                </div>
                <h1 className='title'>{t.password_recovery} 3/3</h1>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit();
                }} className='fields'>
                    <Field
                        value={password}
                        label={t.new_password}
                        placeholder={t.enter_new_password}
                        error={errors.password?.message}
                        type="password"
                        {...registerField('password')}                    
                    />

                    <MainButton text={t.update_password} type="submit" />
                </form>
            </div>
        </div>
    );
}